import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import QText from './QText';
import { useTheme } from 'react-native-paper';

const LinkButton = ({ titleStyle, style, title, ...props }) => {
  const theme = useTheme();
  return (
    <View style={styles.linkBtnContainer}>
      <TouchableOpacity style={[styles.button, style]} {...props}>
        <QText
          style={[
            { color: theme.colors.primary, textAlign: 'center', fontSize: 14 },
            titleStyle,
          ]}
        >
          {title}
        </QText>
      </TouchableOpacity>
    </View>
  );
};

LinkButton.propTypes = {
  titleStyle: PropTypes.object,
  style: PropTypes.object,
  title: PropTypes.string,
};

LinkButton.defaultProps = {
  titleStyle: {},
  style: {},
  title: '',
};

const styles = StyleSheet.create({
  linkBtnContainer: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginVertical: 10,
  },
});

export default memo(LinkButton);
